export const goalArenaPresentation = {
  renderer: { maxPixelRatio: 1.65, exposure: 1.08 },
  camera: { fov: 50, x: 0, y: 1.7, z: 9.6, lookAtX: 0, lookAtY: 1.25, lookAtZ: -9.8 },
  field: { width: 34, length: 52, centerZ: -5.5, textureSize: 1024 },
  goal: { width: 7.32, height: 2.44, depth: 2.05, z: -10.2, postRadius: 0.065 },
  ball: { radius: 0.22, x: 0, y: 0.225, z: 1.2 },
  crowd: { columns: 44, rows: 6, spacingX: 0.72, tierRise: 0.46 },
  effects: { goalParticles: 30, goalParticleDuration: 0.95, cameraImpulse: 0.035 },
  colors: {
    sky: 0x030912,
    fog: 0x07111d,
    grass: '#17672f',
    grassDark: '#0f5425',
    grassLight: '#22783a',
    line: '#f4f7f2',
    structure: 0x17212f,
    led: 0x38d7ff,
    warm: 0xffd786,
  },
} as const;

export const goalAudioPresentation = {
  masterGain: 0.82,
  ambienceGain: 0.032,
  reverbSeconds: 1.45,
  reverbDecay: 2.25,
} as const;
